<template>
  <div>
    <!-- QUIZ -->
    <div v-for="(question, qIndex) in dataQuiz" :key="question.id" class="question-block">
      <div class="box_question_quiz" :class="{ review }">
        <div class="number_question_quiz">
          <span>Questão {{ qIndex + 1 }}</span>
        </div>
        <div class="title_question_quiz">
          <span v-html="question.description"></span>
        </div>

        <div v-for="(option, oIndex) in question.answers" :key="option.id" class="option_question_quiz">
          <input
            type="radio"
            :id="`option${qIndex}_${oIndex}`"
            :name="`question_${qIndex}`"
            :checked="selectedOptions[qIndex] && selectedOptions[qIndex].posicao === oIndex"
            :disabled="review"
            @change="handleSelectOption(qIndex, oIndex, option.id, question.id)"
            class="hidden-radio"
          />

        <!-- Ícone de resposta correta -->
          <i
          class="pi pi-check"
          v-if="review && option.correct"
          />

          <!-- Ícone de resposta errada -->
          <i
          class="pi pi-times"
          v-if="
          review &&
          selectedOptions[qIndex] &&
          oIndex === selectedOptions[qIndex].posicao &&
          !option.correct
          "
          />

          <label
            :for="`option${qIndex}_${oIndex}`"
            class="option-label"
            @click="handleSelectOption(qIndex, oIndex, option.id, question.id)"
          >
            <span
              :class="[
                'option_input',
                {
                  selected: selectedOptions[qIndex] && oIndex === selectedOptions[qIndex].posicao,
                  correct: review && option.correct,
                  incorrect: review && !option.correct && selectedOptions[qIndex] && oIndex === selectedOptions[qIndex].posicao
                }
              ]"
            >{{ optionLabels[oIndex] }}</span>
            <span :class="{ selected: selectedOptions[qIndex] && oIndex === selectedOptions[qIndex].posicao }">
              <span v-html="option.description"></span>
            </span>
          </label>
        </div>
      </div>
    </div>
  <div v-if="!review && !loading" class="enviar-quiz-container" style="margin-top: 24px; text-align: right;">
    <button
      class="btn-enviar-quiz"
      :disabled="selectedOptions.length !== dataQuiz.length || selectedOptions.includes(undefined) || selectedOptions.includes(null)"
      @click="submitAnswer"
      style="padding: 10px 24px; background: #26bdbe; color: #fff; border: none; border-radius: 4px; font-size: 16px; cursor: pointer;"
    >
      Finalizar Avaliação
    </button>
  </div>
  </div>
</template>

<script>
import api from '@/utils/portal/quiz';
import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';


export default {
  props: {
    review: Boolean,
    dataQuiz: { type: Array, required: true },
    userAmswer: { // Recebe as respostas do usuário
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedOptions: [],
      arrayAnswer: [],
      optionLabels: ['A', 'B', 'C', 'D', 'E'],
      revisaoRespostas: [],
      loading: false
    };
  },
  computed: {
    ...mapState([
      'token',
      'currentModuleOpen',
      'idLessonPortal',
      'nameCurrentLesson',
      'typeLessonPortal'
    ])
  },
  methods: {
    handleSelectOption(qIndex, oIndex, id, questionId) {
      if (!this.review) {
        const updated = [...this.selectedOptions];
        updated[qIndex] = {
          posicao: oIndex,
          questao: questionId,
          id: id
        };
        this.selectedOptions = updated;
        this.arrayAnswer = this.selectedOptions.map(opt => opt ? opt.id : null);
      }
    },
    marcarAlternativasUsuario() {
  const selectedOptions = Array(this.dataQuiz.length).fill(null);

  if (this.review && Array.isArray(this.userAmswer) && this.userAmswer.length > 0) {
    this.dataQuiz.forEach((question, qIdx) => {
      // Procura a resposta do usuário com base no token da questão
      const respostaUsuario = this.userAmswer.find(ans => {
        return (
          ans.tokenQuestion === question.id ||
          ans.idQuestion === question.id || // fallback
          ans.question_id === question.id
        );
      });

      if (respostaUsuario) {
        // Usa o token da alternativa marcada para encontrar a posição correta
        const tokenAlternativaUsuario = respostaUsuario.tokenAnswer;
        const idxAlternativa = question.answers.findIndex(opt => opt.id === tokenAlternativaUsuario);

        if (idxAlternativa !== -1) {
          selectedOptions[qIdx] = {
            posicao: idxAlternativa,
            questao: question.id,
            id: tokenAlternativaUsuario
          };
        }
      }
    });
  }

  this.selectedOptions = selectedOptions;
  this.arrayAnswer = this.selectedOptions.map(opt => opt ? opt.id : null);
  this.gerarResumoRevisao();
},
    gerarResumoRevisao() {
      // Gera o resumo da revisão para exibir no template
      if (!this.review) {
        this.revisaoRespostas = [];
        return;
      }
      this.revisaoRespostas = this.dataQuiz.map((question, qIdx) => {
        // Alternativa correta
        const idxCorreta = question.answers.findIndex(opt => opt.correct);
        const respostaCorreta = idxCorreta !== -1 ? this.optionLabels[idxCorreta] : '-';

        // Alternativa marcada pelo usuário
        const marcada = this.selectedOptions[qIdx];
        const respostaUsuario = marcada && marcada.posicao !== undefined ? this.optionLabels[marcada.posicao] : null;

        // Acertou?
        const acertou = marcada && idxCorreta === marcada.posicao;

        return {
          respostaCorreta,
          respostaUsuario,
          acertou
        };
      });
    },
    async submitAnswer() {
      const payload = {
        answers: this.arrayAnswer
      };
      try {
        const response = await api.submitAnswers(this.token, payload, this.idLessonPortal);
        toast.success('Respostas enviadas com sucesso!');
        
        // Emite evento para o componente pai atualizar os dados
        this.$emit('quiz-submitted');
        
        // Apenas debug, pode remover se não quiser log
        // console.debug('Resposta enviada:', response);
      } catch (error) {
        toast.error('Erro ao enviar as respostas!');
        // Apenas debug, pode remover se não quiser log
        // console.error('Erro ao enviar resposta:', error);
      }
    },
    initializeSelections() {
      this.selectedOptions = Array(this.dataQuiz.length).fill(null);
      this.arrayAnswer = [];
      this.gerarResumoRevisao();
    }
  },
  created() {
    this.initializeSelections();
    this.marcarAlternativasUsuario();
  },
  watch: {
    review(newVal) {
      if (newVal) {
        this.marcarAlternativasUsuario();
        this.$emit('answer', this.selectedOptions);
      }
    },
    userAmswer: {
      handler() {
        if (this.review) {
          this.marcarAlternativasUsuario();
        }
      },
      immediate: true,
      deep: true
    },
    dataQuiz: {
      handler() {
        this.initializeSelections();
        if (this.review) {
          this.marcarAlternativasUsuario();
        }
      },
      immediate: true
    },
    currentLesson() {
      // Watcher removido - não é mais necessário
    }
  }
};
</script>

<style scoped>
@import './index.css';

.hidden-radio {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.option-label {
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
}
.box_question_quiz_button button {
  background-color: #45c145;
  padding: 10px 40px;
  color: white;
  border: 1px solid #45c145;
  border-radius: 5px;
}
</style>
